export default {
    skillsNames: [
        "Antropologia",
        "Armas Brancas",
        "Armas de Fogo",
        "Arqueologia",
        "Arremessar",
        "Arrombamento",
        "Arte",
        "Astronomia",
        "Atletismo",
        "Avaliar Honestidade",
        "Barganhar",
        "Biologia",
        "Charme",
        "Chaveiro",
        "Ciência Forense",
        "Consertos Elétricos",
        "Consertos Mecânicos",
        "Computação",
        "Criptografia",
        "Direito",
        "Dirigir Automóveis",
        "Disfarce",
        "Eletrônica",
        "Encontrar",
        "Escalar",
        "Escutar",
        "Esquivar",
        "Etiqueta",
        "Farmácia",
        "Flertar",
        "Fotografia",
        "Furtividade",
        "História",
        "Interrogação",
        "Intimidação",
        "Lábia",
        "Língua Nativa",
        "Língua Estrangeira",
        "Lutar",
        "Maldições",
        "Manha",
        "Medicina",
        "Natação",
        "Ofício",
        "Persuadir",
        "Pesquisar Biblioteca",
        "Pilotar",
        "Primeiros Socorros",
        "Psicanálise",
        "Pular",
        "Química",
        "Rastrear",
        "Sobrevivência",
        "Teologia"],
    skillsNumbers: {
    //  DADO: [NORMAL, BOM, EXTREMO]
        1: [20, 21, 21],
        2: [19, 20, 21],
        3: [18, 20, 21],
        4: [17, 19, 21],
        5: [16, 19, 20],
        6: [15, 18, 20],
        7: [14, 18, 20],
        8: [13, 17, 20],
        9: [12, 17, 20],
        10: [11, 16, 19],
        11: [10, 16, 19],
        12: [9, 15, 19],
        13: [8, 15, 19],
        14: [7, 14, 18],
        15: [6, 14, 18],
        16: [5, 13, 18],
        17: [4, 13, 18],
        18: [3, 12, 18],
        19: [2, 12, 18],
        20: [1, 11, 17],
    }
    
}